import React, { useRef, useEffect, useCallback, useState} from 'react';
import Grids from "components/explore/details/Grids.js";
import {connect} from 'react-redux';

const MIN_SCALE = 0.30;
const GridsContainer = ({scale, setScale, sequencerEngine}) => { 
    const ref = useRef(ref);

    useEffect(() => {
        ref.current.addEventListener("mousewheel", onMouseWheel);
        return () => ref.current.removeEventListener("mousewheel", onMouseWheel);
    }, [setScale, scale]);

    const onMouseWheel = useCallback((e) => {
        let {deltaX, deltaY, wheelDeltaX, wheelDeltaY} = e;
        if (!e.ctrlKey) { return; }
        if (Math.abs(wheelDeltaY) > 80 ||
            (Math.abs(wheelDeltaY) > 40 && Math.abs(deltaX) < 20 && Math.abs(deltaY) < 20)) {
            e.preventDefault();
            let _scale=1;
            if (wheelDeltaY > 0) {
                _scale =  scale * wheelDeltaY / 115.0;
            } else {
                _scale = Math.abs(scale / (wheelDeltaY / 115.0));
            }
            window._scale = Math.max(MIN_SCALE, Math.min(1, _scale));
            setScale(Math.max(MIN_SCALE, Math.min(1, _scale)));
        } 
    }, [setScale, scale]);

    let style = {

    };
    if (scale !== 1) {
        style.transform = "scale(" + scale + ")";
    }
    return (
        <div ref={ref} className="grids-box">
          <div style={style} className="grids-container">
            {sequencerEngine.subSequences.map(
                subSequence => 
                    <Grids
                      key={subSequence.id}
                      scale={scale}
                      showEffects={true}
                      subSequence={subSequence}
                      sequencerEngine={sequencerEngine}/>)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GridsContainer);
